import { createReducer, on } from '@ngrx/store';
import { initialActuacionContractualState } from './actuacion-contractual.state';
import * as ActuacionContractualActions from './actuacion-contractual.actions';

export const actuacionContractualReducer = createReducer(
  initialActuacionContractualState,

  // Load Actions
  on(ActuacionContractualActions.loadActuacionesContractuales, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    ActuacionContractualActions.loadActuacionesContractualesSuccess,
    (state, { actuacionesContractuales, loadedAt }) => ({
      ...state,
      actuacionesContractuales,
      loading: false,
      error: null,
      lastLoadedAt: loadedAt ?? Date.now()
    })
  ),
  on(ActuacionContractualActions.loadActuacionesContractualesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Actions
  on(ActuacionContractualActions.createActuacionContractual, state => ({
    ...state,
    creating: true,
    error: null
  })),
  on(
    ActuacionContractualActions.createActuacionContractualSuccess,
    (state, { actuacionContractual }) => ({
      ...state,
      actuacionesContractuales: [...state.actuacionesContractuales, actuacionContractual],
      creating: false,
      error: null
    })
  ),
  on(ActuacionContractualActions.createActuacionContractualFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update Actions
  on(ActuacionContractualActions.updateActuacionContractual, state => ({
    ...state,
    updating: true,
    error: null
  })),
  on(
    ActuacionContractualActions.updateActuacionContractualSuccess,
    (state, { actuacionContractual }) => ({
      ...state,
      actuacionesContractuales: state.actuacionesContractuales.map(ac =>
        ac.actuacionId === actuacionContractual.actuacionId ? actuacionContractual : ac
      ),
      updating: false,
      error: null
    })
  ),
  on(ActuacionContractualActions.updateActuacionContractualFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Toggle Status Actions
  on(ActuacionContractualActions.toggleActuacionContractualStatus, state => ({
    ...state,
    updating: true,
    error: null
  })),
  on(
    ActuacionContractualActions.toggleActuacionContractualStatusSuccess,
    (state, { id, isActive }) => ({
      ...state,
      actuacionesContractuales: state.actuacionesContractuales.map(ac =>
        ac.actuacionId === id ? { ...ac, estado: isActive } : ac
      ),
      updating: false,
      error: null
    })
  ),
  on(ActuacionContractualActions.toggleActuacionContractualStatusFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Delete Actions
  on(ActuacionContractualActions.deleteActuacionContractual, state => ({
    ...state,
    deleting: true,
    error: null
  })),
  on(ActuacionContractualActions.deleteActuacionContractualSuccess, (state, { id }) => ({
    ...state,
    actuacionesContractuales: state.actuacionesContractuales.filter(ac => ac.actuacionId !== id),
    deleting: false,
    error: null
  })),
  on(ActuacionContractualActions.deleteActuacionContractualFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error
  })),

  // Search Actions
  on(ActuacionContractualActions.searchActuacionesContractuales, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    ActuacionContractualActions.searchActuacionesContractualesSuccess,
    (state, { searchResults }) => ({
      ...state,
      searchResults,
      loading: false,
      error: null
    })
  ),
  on(ActuacionContractualActions.searchActuacionesContractualesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(ActuacionContractualActions.clearActuacionContractualSearch, state => ({
    ...state,
    searchResults: []
  })),

  // Select Actions
  on(ActuacionContractualActions.selectActuacionContractual, (state, { actuacionContractual }) => ({
    ...state,
    selectedActuacionContractual: actuacionContractual
  })),
  on(ActuacionContractualActions.clearActuacionContractualSelection, state => ({
    ...state,
    selectedActuacionContractual: null
  }))
);
